import { Observer } from '@babylonjs/core/Misc/observable';
import { Viewport } from '@babylonjs/core/Maths/math.viewport';
import { Matrix, Vector2, Vector3 } from '@babylonjs/core/Maths/math.vector';
import { el } from 'redom';

import './uiFollowPoint.sass';
import { SystemUi } from '../System/systemUi';
import { UiElement, setElementStyle } from './uiElement';

export class UiFollowPoint extends UiElement {
    constructor(
        system: SystemUi,
        container: HTMLElement,
    ) {
        super(system, container);
        this.setSize({ width: 400, height: 400 });
        this.hide();
        this.addBlocks();
    }

    private title: HTMLElement

    public point: HTMLElement

    private lineWidth: HTMLElement

    private lineRotation: HTMLElement

    private addBlocks() {
        this.title = el('div.naker-hover-title');
        this.title.style.opacity = '0';
        this.addSubElement(this.title);
        this.point = el('div.naker-hover-point');
        this.addSubElement(this.point);
        this.lineRotation = el('div.naker-hover-line');
        this.addSubElement(this.lineRotation);
        this.lineWidth = el('div.naker-hover-line-width');
        this.lineWidth.style.opacity = '0';
        this.lineRotation.appendChild(this.lineWidth);
    }

    public delete(): void {
        this.container.removeChild(this.el);
    }

    private centerStyle = {
        display: 'block',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transition: 'all ease 200ms',
    }

    private addSubElement(el: HTMLElement) {
        setElementStyle(el, this.centerStyle);
        this.el.appendChild(el);
    }

    private setText(text: string) {
        this.title.textContent = text;
    }

    protected setPositionFromTopLeft(position: Vector2): void {
        const { canvas, engine } = this.system;
        position.x -= canvas.width / 2;
        position.y -= canvas.height / 2;
        position.x *= engine.getHardwareScalingLevel();
        position.y *= engine.getHardwareScalingLevel();
        this.setPosition(position);
    }

    private _keepPointVisible = false;

    public set keepPointVisible(v : boolean) {
        this._keepPointVisible = v;
        if (v) this.point.style.opacity = '1';
        else this.point.style.opacity = '0';
    }

    public showAnim(): void {
        this.show();
        this.title.style.opacity = '1';
        if (!this._keepPointVisible) this.point.style.opacity = '1';
        this.lineWidth.style.opacity = '1';
        this.lineWidth.style.width = '120px';
    }

    public hideAnim(callback?: () => void): void {
        this.title.style.opacity = '0';
        if (!this._keepPointVisible) this.point.style.opacity = '0';
        this.lineWidth.style.width = '0px';
        setTimeout(() => {
            this.lineWidth.style.opacity = '0';
        }, 200);
        setTimeout(() => {
            if (!this._keepPointVisible) this.hide();
            if (callback) callback();
        }, 600);
    }

    private obsever: Observer<null>;

    public followPoint(point: Vector3, text: string): void {
        this.pointToFollow = point;
        const { scene } = this.system;
        scene.updateTransformMatrix();
        if (point) {
            this.setText(text);
            const { onBeforeRenderObservable } = this.system.scene;
            this.obsever = onBeforeRenderObservable.add(() => { this.setCameraPosition(); });
            this.setCameraPosition();
        } else if (this.obsever) {
            this.system.scene.onBeforeRenderObservable.remove(this.obsever);
        }
    }

    pointToFollow: Vector3;

    private setCameraPosition() {
        if (this.pointToFollow) {
            const { scene, canvas } = this.system;

            const pos = Vector3.Project(
                this.pointToFollow,
                Matrix.Identity(), // world matrix
                scene.getTransformMatrix(), // transform matrix
                new Viewport(0, 0, canvas.width, canvas.height)
            );
            this.setPositionFromTopLeft(new Vector2(pos.x, pos.y));
        }
    }
}
